export const FILE_TYPES = {
    IMAGE_JPG: ".jpg",
    IMAGE_JPEG: ".jpeg",
    IMAGE_BMP: ".bmp",
    IMAGE_PNG: ".png",
    FILE_PDF: ".pdf",
    FILE_ZIP: ".zip"
};